<template>
  <main class="main main--dentists">
    <div class="gradient-bg"/>

    <component
      v-for="(component, index) in components"
      :key="index"

      :is="component"
    />

    <ui-footer/>
  </main>
</template>

<script>
// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiFooter from 'ui/Footer';

// Pages
import PagesReviewerHero from 'pages/infoReviewers/Hero';
import PagesReviewerInstructions from 'pages/infoReviewers/Instructions';
import PagesReviewerMission from 'pages/infoReviewers/OurMission';
import PagesReviewerSignup from 'pages/home/Dentists';

// Export
export default {
  name: `view-info-reviewer`,

  // Meta data
  metaInfo: {
    title: meta.infoReviewers.title,
    meta: createMeta(meta.infoReviewers.meta),
  },

  // Components
  components: {
    UiFooter,
  },

  // Data
  data() {
    return {
      components: {
        PagesReviewerHero,
        PagesReviewerInstructions,
        PagesReviewerMission,
        PagesReviewerSignup,
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// InfoReviewers.vue?b25d83ae